import { FluxErrors } from './errors.js';
import type { ExtractedMessages } from './utils/extract-messages.js';
import { extractMessages } from './utils/extract-messages.js';

export type FluxErrorMessage = ExtractedMessages<typeof FluxErrors>;

/**
 * Objeto com todas as mensagens de erro disponíveis no Flux. Esse objeto é derivado
 * do objeto `FluxErrors`, sua única diferença é que as chaves desse objeto são os códigos
 * de erro no formato `${Categoria}/${Erro}` e os valores são o metadata dos erros, incluindo
 * a mensagem de erro.
 */
export const FLUX_ERROR_MESSAGES = extractMessages(FluxErrors);
